<template>
    <div ref="slider" class="slider text-yanone text-bold text-white" v-lazy="initSlider">
        <p class="header-advantage-item" v-if="$scope.CONFIG.FRETE_VALOR_FIXO_HABILITADO && $scope.CONFIG.FRETE_VALOR_FIXO == 0">
            <i class="icon-cr icon-carrier white"></i>Frete grátis para todo Brasil*
        </p>
        <p class="header-advantage-item" v-else>
            <i class="icon-cr icon-carrier white"></i>Frete grátis em pedidos acima de R${{$scope.CONFIG.VALOR_FRETE_GRATIS}}*
        </p>
        <p class="header-advantage-item"><i class="icon-cr icon-exchange white"></i>Sua 1ª troca no site é grátis*</p>
        <p class="header-advantage-item"><i class="icon-cr icon-credit-card white"></i>4x sem juros</p>
    </div>
</template>

<script>
    import Slider from "../../../common/hammer-slider";

    export default {
        name: "HeaderAdvantagesSlider",

        methods: {
            initSlider() {
                new Slider(this.$refs.slider).init({
                    orientation: 'vertical',
                    loop: true,
                    adaptOnResize: false,
                    enableBullets: false,
                    autoplayInterval: 3000,
                });
            }
        }
    }
</script>